import results from './results'

const {
  dashboard,
  discover,
  myColleges,
  recsDocs,
  messageCenter,
  myProfile,
  applications,
  visitsDeadlines,
  surveys,
  sessions,
  compare,
  myMatches,
  events,
  posts,
  programs,
} = results

export const keywordsObj = {
  home: dashboard,
  dashboard: dashboard,

  find: discover,
  discover: discover,
  search: discover,
  browse: discover,
  explore: discover,

  'my colleges': myColleges,
  'my list': myColleges,
  favorites: myColleges,
  'my favorites': myColleges,
  'added colleges': myColleges,
  'my likes': myColleges,
  likes: myColleges,
  list: myColleges,
  colleges: myColleges,
  suggest: myColleges,
  suggested: myColleges,
  suggestions: myColleges,
  saved: myColleges,
  bookmarked: myColleges,
  following: myColleges,
  applying: myColleges,
  applied: myColleges,
  'not interested': myColleges,
  'applications myColleges': myColleges,
  transcripts: myColleges,

  'recs & docs': recsDocs,
  documents: recsDocs,
  'letter of recommendation': recsDocs,
  'letters of recommendation': recsDocs,

  messages: messageCenter,
  outreach: messageCenter,
  inbox: messageCenter,
  'message center': messageCenter,
  reply: messageCenter,
  notifications: messageCenter,
  dm: messageCenter,
  'direct messages': messageCenter,
  'college messages': messageCenter,

  me: myProfile,
  'my profile': myProfile,
  profile: myProfile,
  activities: myProfile,
  achievements: myProfile,
  resume: myProfile,
  preferences: myProfile,
  'my drive': myProfile,
  'career profile': myProfile,
  'invite parent': myProfile,
  bio: myProfile,
  'change password': myProfile,
  password: myProfile,
  'delete account': myProfile,
  account: myProfile,

  'applications applyWithScoir': applications,
  'apply with scoir': applications,

  events: events,
  upcoming: events,
  'visits & deadlines': visitsDeadlines,
  deadlines: visitsDeadlines,
  visits: visitsDeadlines,
  'college visits': visitsDeadlines,
  'registered visits': visitsDeadlines,
  'office hours': visitsDeadlines,
  counselor: visitsDeadlines,

  surveys: surveys,
  form: surveys,
  sessions: sessions,
  'college sessions': sessions,
  'info sessions': sessions,
  'information sessions': sessions,

  compare: compare,
  'college compare': compare,

  'my matches': myMatches,
  quiz: myMatches,
  match: myMatches,
  'college matches': myMatches,

  posts: posts,

  programs: programs,
  'summer programs': programs,
  'high school programs': programs,
  'pre-college programs': programs,
  'enrichment programs': programs,
}

export const keywordsArr = Object.keys(keywordsObj)
